import { Injectable } from '@angular/core';
import * as fromRoot from '../../state';
import { Store } from '@ngrx/store';
import { Resolve } from '@angular/router';
import { SessionService } from './session.service';
import * as appActions from '../../state/app.actions';

@Injectable({
  providedIn: 'root'
})
export class UserResolverService implements Resolve<any> {
  constructor(
    private store$: Store<fromRoot.State>,
    private sessionService: SessionService
  ) {
    // load live user if authentication is available
    if (sessionService.getToken()) {
      store$.dispatch(new appActions.LoadUser());
    }
  }

  resolve(): any {
    return null;
  }
}
